import React from "react";

const LinearLoadingBar = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-1 z-50">
      <div className="h-full bg-gradient-to-r fbg-gradient-to-r from-red-700 via-red-800 to-red-900 animate-loading"></div>
    </div>
  );
};

export default LinearLoadingBar;
